module.exports = __webpack_public_path__ + "static/media/sinais.defcc1f1.png";